module.exports = __webpack_public_path__ + "img/Yousuf.bd8dce45.webp";